import { useQuery } from '@tanstack/react-query';
import type { CandidateProfileResponse } from '../types/CandidateProfile';
import { ApiError } from '@/utils/apiFetch';

export default function useFetchCandidateProfile(id: number | null) {
  return useQuery({
    queryKey: ['candidateProfile', id],
    enabled: id !== null,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await fetch(`/agent/api/candidate_profiles/${id}.json`);

      // 404（存在しない/権限外）などの失敗レスポンスをそのまま data として返すと、
      // 呼び出し側で counter_cache 等の未定義プロパティ参照でクラッシュするため、
      // ここで例外を投げてクエリをエラー状態にする（NotFound 表示へ分岐させる）
      if (!response.ok) {
        throw new ApiError(response.status, '求職者情報の取得に失敗しました');
      }

      const data: CandidateProfileResponse = await response.json();
      return data;
    },
    retry: (failureCount, error) => {
      // 4xx（見つからない/権限外/不正リクエスト）はリトライしても無駄なので即座に諦める
      const status = (error as Error & { status?: number })?.status;
      if (status !== undefined && status >= 400 && status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
